var SSegment = (function () {

    function _afterDelete(ids, notDeletedIds, single) {

        var deletedIds = notDeletedIds && notDeletedIds.length ? ids.filter(function (id) {
            return notDeletedIds.indexOf(id) === -1;
        }) : ids;
        _refreshTable(true, deletedIds);

        var segmentIds = [];
        if (notDeletedIds && notDeletedIds.length > 0) {
            notDeletedIds.forEach(function(id) {
                if (segmentIds.indexOf(id) === -1) {
                    segmentIds.push(id);
                }
            });
        }

        var hasError = segmentIds.length > 0;
        if (hasError) {
            var desc = null;
            if (single) {
                desc = 'Удаление невозможно: с данным участком связаны работы.';
            } else {
                desc = 'Участки обслуживания с идентификаторами ' +
                    segmentIds.join(', ') +
                    ' не были удалены: с данными участками связаны работы.';
            }
            ModalConductor.activate(MessageModal, $('#message-tmpl').text(), 'Внимание!', desc);
        }
        return !hasError;
    };

  function deleteObjects(ids) {
      return $.ajax({
          url: Url.action('api/ssegments'),
          type: 'DELETE',
          data: { ids: ids }
      });
  };

  function _show(id) {
    var modal = ModalConductor.activate(SSegmentViewModal, id,
      (ssegmentId) => {
          deleteObjects([ssegmentId]).done((result) => {
              modal.close();
              var deleteSuccess = _afterDelete([ssegmentId], result, true);
        });
      },
      (ssegmentId) => {
        _showOnMap([ssegmentId]);
      })
    .on('closed', (modalResult) => _refreshTable());
  };

  function _add() {
    ModalConductor.activate(SSegmentEdtiModal)
      .on('closed',
        (modalResult) => {
          if (modalResult.ok) {
            _refreshTable();
          }
        });
  };

  function _delete(ids, table) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      deleteObjects(ids).done((result) => _afterDelete(ids, result));
    }
  };

  function _showOnMap(ids) {
    if (ids.length > 0) {
      location.href = Url.map(ObjectTypes.SSegment, ids);
    }
  };

    function _refreshTable(resetChecked, rowsForDeselect) {
      var table = $('#SSegmentListItemViewModelTable').DataTable();
        refreshTable(table, resetChecked, null, rowsForDeselect);
  };

  return {
    show: _show,
    add: _add,
    del: _delete,
    showOnMap: _showOnMap
  };
}());
